module.exports = __webpack_public_path__ + "static/media/Gamesimg.96b4a6e9.png";